import React, {useLayoutEffect} from 'react';

// components
import Header from '../Header';
import Footer from "../Footer";


//style
import "./Page.scss";

const Page = ({children}) => {

	useLayoutEffect( () => {

		console.log(window.pageId)
		if(window.pageId !== 6) {
			window.scrollTo({
				top:0,
				left:0,
				behavior:"instant"
			});		}
	},[]);

	return (
		<div className={`page ${window.pageId !== 6 ? "subpage" : "home"}`}>
			<Header/>
				<main>
					{children}
				</main>
			<Footer/>
		</div>
	);
};


export default Page;

